import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

type AccessDeniedReason = 'forbidden' | 'not-found';

@Component({
  selector: 'app-access-denied',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './access-denied.component.html',
  styleUrl: './access-denied.component.css',
})
export class AccessDeniedComponent {
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  reason = computed<AccessDeniedReason>(() => {
    const value = this.route.snapshot.queryParamMap.get('reason');
    return value === 'not-found' ? 'not-found' : 'forbidden';
  });

  requestedPath = computed(() => this.route.snapshot.queryParamMap.get('from') || '');

  title = computed(() =>
    this.reason() === 'not-found' ? 'ไม่พบหน้าที่ต้องการ' : 'ไม่มีสิทธิ์เข้าถึง',
  );

  description = computed(() => {
    if (this.reason() === 'not-found') {
      return 'หน้าที่คุณพยายามเข้าถึงไม่มีอยู่ในระบบ หรือ URL ไม่ถูกต้อง';
    }
    return 'บัญชีของคุณไม่มีสิทธิ์เข้าถึงเมนูนี้ กรุณาติดต่อผู้ดูแลระบบหากต้องการสิทธิ์เพิ่มเติม';
  });

  icon = computed(() => (this.reason() === 'not-found' ? 'search_off' : 'lock'));

  goBack(): void {
    if (window.history.length > 1) {
      window.history.back();
      return;
    }
    this.router.navigate(['/dashboard']);
  }
}
